export const TERMS_CATEGORY = {
    TERMS_OF_SERVICE: 'Terms of Service',
    TERMS_OF_PRIVACY: 'Privacy Policy',
};
export const TERMS_TYPE = {
    USER: 'USER',
    INSTALLER: 'INSTALLER',
    SITE: 'SITE',
};
